export type Option = { readonly label: string; readonly value: string };

export function getInitials(name: string) {
  const splitName = name.split(' ');

  if (splitName.length === 1) return splitName[0][0];
  return (splitName[0][0] + splitName[splitName.length - 1][0]).toUpperCase();
}
